var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","max-width":_vm.tooltipMaxWidth},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"info-icon"},on),[_c('v-icon',{attrs:{"color":_vm.infoIconColor,"size":"17.5"}},[_vm._v(" mdi-information ")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }